import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { StateProvider } from "./Components/Common/Context/StateContext";
import {
  ErrorBoundary,
  ErrorFallback,
  myErrorHandler,
} from "./Components/Common/ErrorBoundary";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <StateProvider>
        <ErrorBoundary
          FallbackComponent={ErrorFallback}
          onError={myErrorHandler}
        >
          <App />
        </ErrorBoundary>
      </StateProvider>
    </BrowserRouter>
  // </React.StrictMode>,
);

reportWebVitals();
